import React from "react";
import "./Footer.css";
import "bootstrap-icons/font/bootstrap-icons.css";


export default function Footer() {
  return (
    <footer className="tigps-footer">
        <img
    src="/images/logo-bg.png"
    alt=""
    className="footer-watermark"
  />
      <div className="container-custom">
        <div className="footergrid">
          {/* LEFT: Brand + Socials */}
          <div className="left">
            <div className="brand">
              <div className="logo">
                <img
                          src="/images/tigps-logo.png"
                          alt="Institute Logo"
                          style={{ width: "100%", height: "auto" }}
                        />
              </div>

              <h2 className="brand-title">
                Techno India Group Public<br /> <span> School</span>
              </h2>
            </div>

            <div className="socials">
              <p className="follow-label">Follow Us</p>

              <div className="icons">
                <a href="#" aria-label="Facebook" className="icon facebook">
                  <i className="bi bi-facebook"></i>
                </a>

                <a href="#" aria-label="Instagram" className="icon instagram">
                  <i className="bi bi-instagram"></i>
                </a>

                <a href="#" aria-label="YouTube" className="icon youtube">
                  <i className="bi bi-youtube"></i>
                </a>
              </div>
            </div>
          </div>

          {/* RIGHT: Links + Contact */}
          <div className="right">
            <div className="block">
              <h2 className="block-title">Quick Links</h2>
              <div className="divider" />
              <ul className="links">
                <li><a href="#">About Us</a></li>
                <li><a href="#">Academics</a></li>
                <li><a href="#">Admission</a></li>
                <li><a href="#">Beyond Academic</a></li>
                <li><a href="#">Career</a></li>
              </ul>
            </div>

            <div className="block">
              <h2 className="block-title">Contact Us</h2>
              <div className="divider" />
              <ul className="contact">
                <li>
                  <span className="contact-icon"><i className="bi bi-geo-alt"></i></span>
                  <span>
                    Corporate Office - DN 25, DN Block, Sector V,<br />
                    Bidhannagar, Kolkata, West Bengal 700091
                  </span>
                </li>
                <li>
                  <span className="contact-icon"><i className="bi bi-telephone"></i></span>
                  <a href="tel:7029331692">7029331692</a>
                </li>
                <li>
                  <span className="contact-icon"><i className="bi bi-envelope"></i></span>
                  <a href="mailto:info@tigps.in">info@tigps.in</a>
                </li>
              </ul>

              <p className="copyright">
                Copyright@2025 tigps.in - All Rights Reserved. Made by TIG
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
